import * as React from 'react';
import { Typography } from 'omakase';
import { consumer } from '@tock/coretypes';
import {
  isOfferingDeliveryType,
  isOfferingEventType,
  isOfferingPickupType,
  isOfferingShippingType,
} from 'utils/offerings';

interface Props {
  offering?: consumer.Offering;
}

/**
 *
 * Renders a styled label based on offering, defaults to reservation if no offering is sent
 */
export const ExperienceOfferingDetailsLabel: React.FunctionComponent<Props> = ({ offering }) => {
  let label = 'Reservation';
  let className = 'Consumer-reservationExperienceLabel';

  if (isOfferingDeliveryType(offering)) {
    label = 'Delivery';
    className = 'Consumer-reservationDeliveryLabel';
  }
  if (isOfferingShippingType(offering)) {
    label = 'Shipping';
    className = 'Consumer-reservationDeliveryLabel';
  }
  if (isOfferingPickupType(offering)) {
    label = 'Pickup';
    className = 'Consumer-reservationPickupLabel';
  }
  if (isOfferingEventType(offering)) {
    label = 'Event';
    className = 'Consumer-reservationEventLabel';
  }

  return <ExperienceOfferingDetailsLabelContent label={label} className={className} />;
};

interface ExperienceOfferingDetailsLabelContentProps {
  className?: string;
  label: string;
}
export const ExperienceOfferingDetailsLabelContent: React.FunctionComponent<
  ExperienceOfferingDetailsLabelContentProps
> = ({ label, className = 'Consumer-reservationExperienceLabel' }) => {
  return (
    <Typography className={className} variant="captionStrong" color="fgDefault">
      {label}
    </Typography>
  );
};
